module.exports = __webpack_public_path__ + "static/media/dynamic_pricing_example.a3baa57b.png";